














































import ClientOnly from 'vue-client-only';
import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { EvidencesType } from '~/types/solepro/PageBuilder';
import { v4 as uuidv4 } from 'uuid';
import useProductPage from '~/composables/useProductPage';
import { productTutorialTrack } from '~/helpers/trackings/24orepro/products';
import Modal from '../Modal.vue';

export default defineComponent({
    props: {
        node: {
            type: Object as PropType<EvidencesType>,
            required: true
        }
    },
    components: {
        Modal,
        ClientOnly
    },
    data() {
        return {
            buttonRef: null,
            uniqueId: uuidv4(),
            modalContent: null,
            /*sprite: require('~/assets/solepro/spritemap.svg')*/
        }
    },
    mounted() {
        const elements = document.querySelectorAll(`[id^="button-tutorial-${this.uniqueId}"]`);
        this.buttonRef = elements;
    },
    methods: {
        initTutorial(item) {
            productTutorialTrack(this.product, item.slideName)
            this.modalContent = item;
        },
        resetTutorial() {
            this.modalContent = null;
        },
    },
    setup(props) {
        const { node } = props;
        const tutorial = node.contentType == "evidences" ? node : node.children[0];
        const children = tutorial.children;
        const { product } = useProductPage();

        const getImages = item => {
            if (item.bannerDatas.backgroundType == 'image') {
                const images = JSON.parse(item.bannerDatas.backgroundImages.replaceAll('\\', ''));
                return {
                    desktop: images.desktop_image,
                    mobile: images.mobile_image ? images.mobile_image : images.desktop_image
                }
            } else {
                return {
                    desktop: item['bannerDatas'].videoPreviewSrc,
                    mobile: item['bannerDatas'].videoPreviewSrc
                }
            }
        }

        const items = children.map((item, index) => {
            return {
                index,
                slideName: item['slideName'],
                video: item['bannerDatas'].videoSrc,
                img: {
                    src: getImages(item),
                    alt: item['bannerDatas'].alt
                },
                bannerDatas: item['bannerDatas'],
                isLink: item.cssClasses.includes('slide-link')
            }
        })
        return {
            pbStyle: node.pbStyle,
            product,
            title: tutorial['title'],
            items
        }
    },
})
